import { Component, inject, OnInit } from '@angular/core';
import { first } from 'rxjs';
import { UserDataCDMS } from 'src/app/Interfaces/GeneralCDMS/User/User.interface';
import { Group_Library, Library } from 'src/app/Interfaces/Interfaces-Global/Libraries.interface';
import { UserDataService } from 'src/app/Services/Authentication/User/user-data.service';
import { GeneralLibraryCDMS, LibraryCDMS, typeSystemLibraryCDMS } from 'src/app/types/General/Library.type';
import { GeneralRoleCDMS, typeSystemRoleCDMS } from 'src/app/types/General/RoleCDMS.type';
import { LibraryMasterService } from 'src/app/Services/Libraries/Library-Master/library-master.service';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';
import { firstValueFrom } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-home-of-general-cdms',
    templateUrl: './home-of-general-cdms.component.html',
    styleUrls: ['./home-of-general-cdms.component.scss', '../../../Styles/GlobalStyles.css'],
    standalone: false
})
export class HomeOfGeneralCDMSComponent implements OnInit {

  //+================== VARIABLE LIBRARY GENERAL ==================+\\
  public LibraryGeneral: typeSystemLibraryCDMS = GeneralLibraryCDMS;
  public RolesGeneral: typeSystemRoleCDMS = GeneralRoleCDMS;


  //+================== VARIABLES FOR OPTION CARDS LIBRARIES ==================+\\
  public AllLibrariesCopy: Group_Library[] = []
  public AllLibraries: Group_Library[] = [
    {
      Title: 'Processes',
      NotRelated: [],
      LibraryRole: [this.LibraryGeneral.FIN, this.LibraryGeneral.CCP],
      Library: [
        { Library: 'Processes', Description: 'puede acceder a Processes.', RouteLink: '/Dashboard/FIN', Key: this.LibraryGeneral.FIN, Img: 'Finance Processes.jpg' },
        { Library: 'HOE', Description: 'puede acceder a HOE (Hojas de Operación Estándar).', RouteLink: '/Dashboard/Lib/' + this.LibraryGeneral.CCP, Key: this.LibraryGeneral.CCP, Img: 'Finance Processes.jpg' },
      ],
    }
  ]

  //-========================= SERVICES =========================-\\
  public UserService = inject(UserDataService);
  private MasterLibraryService = inject(LibraryMasterService);

  public dynamicLibraries: any[] = [];
  public CanCreateLibraries: boolean = false;
  public selectedMobileLibSlug: string | null = null;

  public toggleMobileActions(slug: string, event: Event): void {
    if (window.innerWidth <= 1024) {
      event.stopPropagation();
      this.selectedMobileLibSlug = this.selectedMobileLibSlug === slug ? null : slug;
    }
  }

  constructor() { }

  ngOnInit(): void {
    this.fillTemplateHome();
    this.LoadDynamicLibraries();
  }

  async LoadDynamicLibraries() {
    try {
      const res: Response_FIN = await firstValueFrom(this.MasterLibraryService.Get_My_Active_Libraries());
      if (res.success) {
        // Filtrar las que ya son estáticas para no duplicar cards
        this.dynamicLibraries = res.operation.filter((lib: any) => 
          lib.Slug.toLowerCase() !== 'processes' && 
          lib.Slug.toLowerCase() !== 'fin' && 
          lib.Slug.toLowerCase() !== 'ccp' &&
          lib.Slug.toLowerCase() !== 'hoe'
        );
      }
    } catch (e) {
      console.error('Error loading dynamic libraries', e);
    }
  }

  private IsDuplicateLibrarySlugError(payload: any): boolean {
    const operationText = String(payload?.operation || '').toLowerCase();
    const messageText = String(payload?.message || '').toLowerCase();
    const errorText = String(payload?.error || '').toLowerCase();
    const combinedText = `${operationText} ${messageText} ${errorText}`;

    return combinedText.includes('slug ya existe')
      || combinedText.includes('librería con este slug ya existe')
      || combinedText.includes('libreria con este slug ya existe')
      || combinedText.includes('ux_librerias_registradas_slug');
  }

  private IsDuplicateLibraryNameError(payload: any): boolean {
    const operationText = String(payload?.operation || '').toLowerCase();
    const messageText = String(payload?.message || '').toLowerCase();
    const errorText = String(payload?.error || '').toLowerCase();
    const combinedText = `${operationText} ${messageText} ${errorText}`;

    return combinedText.includes('ux_librerias_registradas_nombre')
      || combinedText.includes('ya existe una librería con ese nombre')
      || combinedText.includes('ya existe una libreria con ese nombre');
  }

  private ShowDuplicateSlugMessage(): void {
    Swal.fire('Slug ya en uso', 'Ya existe una librería con ese slug. Ingresa uno diferente.', 'warning');
  }

  private ShowDuplicateNameMessage(): void {
    Swal.fire('Nombre ya en uso', 'Ya existe una librería activa con ese nombre. Usa un nombre diferente.', 'warning');
  }

  public CreateLibrary() {
    if (!this.CanCreateLibraries) {
      Swal.fire('Sin permiso', 'No tienes permisos para crear librerías.', 'warning');
      return;
    }

    Swal.fire({
      title: 'Crear Nueva Librería',
      html: `
        <div style="text-align: left; padding: 10px;">
          <label style="display: block; margin-bottom: 5px; font-weight: 600;">Nombre de la Librería:</label>
          <input id="swal-input-name" class="swal2-input" placeholder="Ej: Calidad" style="margin: 0; width: 100%;">
          
          <label style="display: block; margin-top: 20px; margin-bottom: 5px; font-weight: 600;">Slug (Identificador):</label>
          <input id="swal-input-slug" class="swal2-input" placeholder="Ej: calidad" style="margin: 0; width: 100%;">
          <small style="color: #888;">Este valor se usará en la URL y la base de datos.</small>
        </div>
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'Crear ahora',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#20a8e1',
      preConfirm: () => {
        const name = (document.getElementById('swal-input-name') as HTMLInputElement).value;
        const slug = (document.getElementById('swal-input-slug') as HTMLInputElement).value;
        if (!name || !slug) {
          Swal.showValidationMessage('Ambos campos son obligatorios');
          return false;
        }
        return { name, slug: slug.toLowerCase().trim() };
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Inicializando infraestructura...',
          html: 'Estamos creando la base de datos y clonando las tablas. Por favor espera.',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        try {
          if (result.value) {
            const res: Response_FIN = await firstValueFrom(this.MasterLibraryService.Create_Library(result.value));
            if (res.success) {
              Swal.fire('¡Éxito!', 'Librería creada y registrada correctamente.', 'success').then(() => {
                window.location.reload(); // Recargar para ver los cambios en el sidebar y home
              });
            } else {
              if (this.IsDuplicateLibraryNameError(res)) {
                this.ShowDuplicateNameMessage();
              } else if (this.IsDuplicateLibrarySlugError(res)) {
                this.ShowDuplicateSlugMessage();
              } else {
                Swal.fire('No se pudo crear la librería', res.message || 'Intenta nuevamente.', 'warning');
              }
            }
          }
        } catch (error: any) {
          console.error('Error in CreateLibrary:', error);
          if (this.IsDuplicateLibraryNameError(error?.error)) {
            this.ShowDuplicateNameMessage();
          } else if (this.IsDuplicateLibrarySlugError(error?.error)) {
            this.ShowDuplicateSlugMessage();
          } else {
            Swal.fire('No se pudo crear la librería', error.error?.message || 'Error de conexión con el servidor', 'warning');
          }
        }
      }
    });
  }

  public DeactivateLibrary(lib: any) {
    Swal.fire({
      title: '¿Estás seguro?',
      text: `La librería "${lib.Nombre}" será desactivada y ya no será visible en el dashboard. Podrá ser reactivada por un administrador desde la base de datos si es necesario.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ef4444',
      cancelButtonColor: '#94a3b8',
      confirmButtonText: 'Sí, desactivar',
      cancelButtonText: 'Cancelar'
    }).then(async (result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Desactivando...',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        try {
          const res: Response_FIN = await firstValueFrom(this.MasterLibraryService.Deactivate_Library(lib.Slug));
          if (res.success) {
            Swal.fire('¡Desactivada!', 'La librería ha sido ocultada correctamente.', 'success').then(() => {
              window.location.reload();
            });
          } else {
            Swal.fire('Error', res.message || 'No se pudo desactivar la librería', 'error');
          }
        } catch (error: any) {
          console.error('Error in DeactivateLibrary:', error);
          Swal.fire('Error', error.error?.message || 'Error de conexión con el servidor', 'error');
        }
      }
    });
  }

  private async fillTemplateHome(): Promise<void> {

    this.UserService.GetDataUser.pipe(first(value => value.ID !== 0)).subscribe((userData: UserDataCDMS) => {
      this.CanCreateLibraries = this.UserService.CanCreateLibraries();

      const userLibraries: LibraryCDMS[] = userData.Library;

      const tempAllLibraries: Group_Library[] = [];

      for (const library of this.AllLibraries) {
        const relatedLibraries = this.getRelatedLibraries(library.LibraryRole, userLibraries);
        const isCoreGroup = library.Title === 'Processes'; // El grupo principal es fijo

        if (relatedLibraries.length > 0 || isCoreGroup) {
          const tempLibrary: Group_Library = {
            Title: library.Title,
            NotRelated: [],
            LibraryRole: library.LibraryRole,
            Library: []
          };

          for (const contLibrary of library.Library) {
            const hasRole = userLibraries.find((item: LibraryCDMS) => item.toUpperCase() === contLibrary.Key.toUpperCase());
            const isCoreLibrary = contLibrary.Key === this.LibraryGeneral.FIN || contLibrary.Key === this.LibraryGeneral.CCP;

            if (hasRole || isCoreLibrary) {
              // Librerías core siempre se muestran con ruta normal; el componente de la librería maneja permisos internamente
              tempLibrary.Library.push(contLibrary);
            } else {
              tempLibrary.NotRelated.push(contLibrary.Key);
            }
          }

          if (tempLibrary.Library.length > 0) {
            tempAllLibraries.push(tempLibrary);
          }
        }
      }
      
      this.AllLibraries = tempAllLibraries;

    });
  }

  private getRelatedLibraries(libraryRoles: LibraryCDMS[], userLibraries: LibraryCDMS[]): LibraryCDMS[] {
    return libraryRoles.filter(libraryRole => userLibraries.some(userLibrary => libraryRole === userLibrary));
  }

  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================== FUNCTTION FOR GREETTING ==================-\\

  public GetGreeting(): string {

    let TextGTings: string = '';

    const Date_User = new Date();
    const Hour = Date_User.getHours();

    if (Hour >= 0 && Hour <= 5) {
      TextGTings = 'Buenas noches';
    } else if (Hour >= 6 && Hour <= 11) {
      TextGTings = 'Buenos días';
    } else if (Hour >= 12 && Hour <= 17) {
      TextGTings = 'Buenas tardes';
    } else if (Hour >= 18) {
      TextGTings = 'Buenas noches';
    }

    return TextGTings;
  }

  //-================ FUNCTION FOR NAME USER ================-\\
  public NameUser(): string {
    const Name_User: string = localStorage.getItem('Name_User') || "";
    return (Name_User.split(' ', 2)).join(' ');
  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\
}

